import {PopupForm} from '../modules/PopupForm';

var popupFormSimple = function(wrapper){
	new PopupForm({
		wrapper: wrapper,
		onsuccess: function(data){
			uPopup.closeAll();
			uPopup({
				content:data.message
			});
		}
	});
};

export {popupFormSimple};



